import loadable from 'react-loadable';
import Loading from '../common/Loading';

export default loadable({
  loader: () => import(/* webpackChunkName: "PondGallery" */ './PondGallery'),
  loading: Loading,
  delay: 300,
});



// WEBPACK FOOTER //
// ./src/features/pond/PondGalleryLoadable.js